var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarDayOutlined = function SvgCalendarDayOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendarDayOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.15 4.88V3.67c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.325l-.31.025c-1.85.18-3.68 1.95-3.88 3.8-.27 2.74-.27 5.47 0 8.21.2 1.85 2.04 3.62 3.88 3.8a60.4 60.4 0 0 0 10.06 0c1.85-.18 3.68-1.95 3.88-3.8.27-2.74.27-5.47 0-8.21-.2-1.85-2.04-3.62-3.88-3.8l-.52-.041V3.67c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.201a60 60 0 0 0-5.63.01M7.17 6.62a57 57 0 0 1 9.78 0c1 .1 2.07 1.05 2.37 2.02H4.82c.31-.98 1.37-1.92 2.35-2.02m12.22 10.23c-.12 1.09-1.33 2.27-2.43 2.38a57 57 0 0 1-9.78 0c-1.11-.11-2.33-1.29-2.44-2.36-.22-2.2-.24-4.43-.09-6.64h14.83c.15 2.21.12 4.43-.09 6.62m-9.7-1.24c-.76.04-1.52.04-2.27 0-.52-.03-.99-.5-1.02-1.02-.04-.76-.04-1.52 0-2.27.03-.52.5-.99 1.02-1.02.76-.04 1.52-.04 2.27 0 .52.03.99.5 1.02 1.02.04.76.04 1.52 0 2.27-.03.52-.5.99-1.02 1.02",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendarDayOutlined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCalendarDayOutlined;